export const defaultEnforcementTypes = [
  {
    id: 3,
    name: "Environmental Health",
    handlesGamblingRelated: false,
    handlesNonGamblingRelated: true,
  },
  {
    id: 4,
    name: "Fire Officer",
    handlesGamblingRelated: false,
    handlesNonGamblingRelated: true,
  },
  {
    id: 6,
    name: "Gambling Comission Officer",
    handlesGamblingRelated: true,
    handlesNonGamblingRelated: false,
  },
  {
    id: 2,
    name: "Local Goverment Officer",
    handlesGamblingRelated: true,
    handlesNonGamblingRelated: true,
  },
  {
    id: 5,
    name: "Other",
    handlesGamblingRelated: false,
    handlesNonGamblingRelated: true,
  },
  {
    id: 1,
    name: "Police",
    handlesGamblingRelated: true,
    handlesNonGamblingRelated: true,
  },
];

export const enforcementTypesToSelect = (options) => {
  // Sort the options by id in ascending order
  options.sort((a, b) => a.id - b.id);

  return options.map((x) => ({
    key: x.id,
    text: x.name,
    value: x.id,
    // Attributes to DOM elements cannot be boolean, and must be converted to string
    gambling: x.handlesGamblingRelated ? "true" : "false",
    nongambling: x.handlesNonGamblingRelated ? "true" : "false",
  }));
};

export const filterEnforcementTypes = (isGamblingRelated, options) =>
  options.filter((option) =>
    isGamblingRelated
      ? option.gambling === "true"
      : option.nongambling === "true",
  );
